 <template>
	<v-container class="noMargin">	    
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>PACKAGES</h2>					
				</div>	
				<v-btn @click.prevent="fncAddPackage" class="elevation-5" color="info"><i class="material-icons">add</i>Create Package</v-btn>				
				<v-btn @click.prevent="fncReloadPackages" class="elevation-5" color="info"><i class="material-icons">refresh</i>Reload</v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
          fncAddPackage() {
                this.$store.dispatch({
                  type: 'setObjPackageAdd'                  
                });
				var modalDetails = { title: 'Add Package', component: 'modal-package-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
          },
          fncReloadPackages() {
            this.$store.dispatch({
              type: 'fncPopulatePackages',
              reload: true
            })
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>